import { Component } from '@angular/core'
import { BaseEventListComponent } from '../event-shared/base-event-list.component'
import { AuthService } from '@shared/services/auth.service'
import { EventService } from '@shared/services/event.service'
import { AttendeesService } from '@shared/services/attendees.service'
import { EventModel } from '@shared/models/event.model'
import { PublicPageTitleService } from '@public/app/services/public-page-title.service'
import { LoadingIndicatorService } from '@public/app/services/loading-indicator.service'
import { ToastService } from '@public/app/services/toast.service'

@Component({
  selector: 'app-my-event-list',
  templateUrl: './my-event-list.component.html',
  styleUrls: ['./my-event-list.component.scss'],
})
export class MyEventListComponent extends BaseEventListComponent {
  pageTitle = 'Eseményeim'
  constructor(
    authService: AuthService,
    eventService: EventService,
    attendeesService: AttendeesService,
    publicPageTitleService: PublicPageTitleService,
    loadingIndicatorService: LoadingIndicatorService,
    toastService: ToastService
  ) {
    super(authService, eventService, attendeesService, publicPageTitleService, loadingIndicatorService, toastService)
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  protected transformEvents(events: EventModel[]): EventModel[] {
    return events.filter(e => e.isRegistered)
  }

  protected updateEventListAfterUnregister(event: EventModel): void {
    this.eventList = this.eventList.filter(e => e.id !== event.id)
  }
}
